import React, { useEffect, useState } from 'react';

const SAST_OFFSET_MIN = 120; // UTC+2

function nextFridayDrawUtcMs() {
  const nowUtcMs = Date.now();
  const sast = new Date(nowUtcMs + SAST_OFFSET_MIN * 60 * 1000);
  const day = sast.getUTCDay(); // 0=Sun ... 5=Fri
  let daysAhead = (5 - day + 7) % 7;
  const hours = sast.getUTCHours();
  const minutes = sast.getUTCMinutes();
  if (daysAhead === 0 && (hours > 18 || (hours === 18 && minutes >= 0))) daysAhead = 7;
  const draw = new Date(
    Date.UTC(
      sast.getUTCFullYear(),
      sast.getUTCMonth(),
      sast.getUTCDate() + daysAhead,
      18,
      0,
      0,
    ),
  );
  return draw.getTime() - SAST_OFFSET_MIN * 60 * 1000;
}

function parts(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return { days, hours, minutes, seconds };
}

const Box = ({ label, value, pulse }) => (
  <div
    data-testid={`countdown-${label.toLowerCase()}`}
    className="card-embossed px-2 sm:px-6 py-4 sm:py-5 text-center"
  >
    <div
      className={`font-serif-display text-3xl sm:text-5xl lg:text-6xl text-gold-gradient font-black leading-none ${
        pulse ? 'pulse-gold' : ''
      }`}
    >
      {String(value).padStart(2, '0')}
    </div>
    <div className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.24em] text-[#C0C0C0]/80">{label}</div>
  </div>
);

export default function Countdown() {
  const [drawMs, setDrawMs] = useState(nextFridayDrawUtcMs());
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (drawMs - now <= 0) setDrawMs(nextFridayDrawUtcMs());
  }, [drawMs, now]);

  const p = parts(drawMs - now);

  return (
    <section
      data-testid="countdown-section"
      className="relative bg-[#0a0a0a] border-y border-[#D4AF37]/15 py-14 sm:py-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-3">Countdown to</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-black">
          <span className="text-gold-gradient">Next Golden Catch Draw In</span>
        </h2>
        <p className="mt-3 text-sm sm:text-base text-[#C0C0C0]">
          Friday 6PM SAST — <span className="text-[#FFD700] font-semibold">R10,000</span> Jackpot
        </p>

        <div className="mt-10 grid grid-cols-4 gap-2 sm:gap-5 max-w-2xl mx-auto">
          <Box label="Days" value={p.days} />
          <Box label="Hours" value={p.hours} />
          <Box label="Minutes" value={p.minutes} />
          <Box label="Seconds" value={p.seconds} pulse />
        </div>
      </div>
    </section>
  );
}
